import { defineMessages } from 'react-intl'

export default defineMessages({
  admin: {
    id: 'containers.CustomerTeamPage.TeamUserCard.admin',
    defaultMessage: 'Admin',
  },
})